import { render, staticRenderFns } from "./menuSort.vue?vue&type=template&id=5e02c092&"
import script from "./menuSort.vue?vue&type=script&lang=js&"
export * from "./menuSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports